import validate from './ClubAthleteRosterFilterFormValidation';

import useForm from "@usas/ui-web/utils/UseForm";
import Constants from '@usas/ui-web/utils/Constants';

const competitionGenderOptions = [
  { id: Constants.DEFAULT_ID, name: "--", value: '' },
  { id: 1, name: "Male", value: 1 },
  { id: 2, name: "Female", value: 2 }
];

const INITIAL_FORM_STATE = {
  competitionGenderTypeId: Constants.DEFAULT_ID,
  competitionGenderTypeName: '',
  minAge: '',
  maxAge: '',
  practiceGroupId: Constants.DEFAULT_ID,
  practiceGroupName: '',
  siteGroupId: Constants.DEFAULT_ID,
  siteGroupName: '',
  firstOrPreferredName: '',
  lastName: ''
};

const useClubAthleteRosterFilterForm = (onSubmitAthleteFilter, onClearAthleteFilter) => {
  const { formState, errorState, setFormData, updateFormState, onValueTextPairChanged, handleSubmit
  } = useForm(INITIAL_FORM_STATE, onSubmitAthleteFilter, validate);

  const onClearFilterClicked = (event) => {
    event?.preventDefault();

    setFormData(INITIAL_FORM_STATE);
    onClearAthleteFilter(event, INITIAL_FORM_STATE);
  };

  return {
    formState,
    errorState,
    onFormValueChanged: updateFormState,
    onValueTextPairChanged,
    handleSubmit,
    onClearFilterClicked,
    competitionGenderOptions
  };
};

export default useClubAthleteRosterFilterForm;